// extracted by mini-css-extract-plugin
module.exports = {"sharePopover":"U","shareText":"V","show":"W"};